
export default API => ({
  getArticleInfo(data){ // 根据多个分类id查询文章列表
      return API({
          url: `/modular/admin/v1/block/getArticleInfo`,
          method: 'post',
          data: data
      });
  },
  /**
   * 文章详情 
   * 
   */
  getArticleDetail(data) {
      return API({
          url: `/cms/v1/article/findById?id=${data.id}`,
          method: 'get',
          data
      });
  },
  getArticleByClass(data) {
      return API({
          url: `/cms/v1/article/getArticleListForClassId`,
          method: 'post',
          data: data,
          headers: {
              'Content-Type': 'application/json'
          }
      })
  },
  /**
   * 文章详情new
   *
   */
  getArticleDetailNew(data) {
      return API({
          url: `/modular/admin/v1/block/getArticleInfo`,
          method: 'post',
          data: data,
          headers: {
              'Content-Type': 'application/json'
          }
      });
  },
  /**
   * 根据id 返回 视频 图片 详情
   *
   */
  getImageList(data) {
      return API({
          url: `/cms/v1/article/getFiles`,
          method: 'post',
          data: data
      });
  },
  // 轮播分类
  getCarouselClass(params) {
    return API({
      url: `/order/v1/admin/goodsCategory/modular/getTree`,
      method: 'get',
      params
    })
  },
  // 获取商品列表
  /*branchId 培训服务商ID
    categoryCode 课程分类code
    categoryId 课程分类id
    name 课程名称/培训服务商名称
    type 排序：1 最新排序 2 销量(人气)排序 3 自定义智能
  */
  getChannelGoodsList(data,params) {
    return API({
      url: `/order/v1/saleSystem/distributionGoods/mall/channelGoodsList`,
      method: 'post',
      data: data,
      params: params
    })
  },
  // 获取自由选择商品
  getFreeGoodsList(data) {
    return API({
      url: `/order/v1/saleSystem/distributionGoods/mall/channelGoodsListByIds`,
      method: 'post',
      data: data
    })
  }
})
